export const BUSINESS_FINANCIALS_SECTION_KEY = "business_financials";

export const BUSINESS_FINANCIALS_FIELD_TYPE = "business_financials";
export const ESTIMATED_TAX_FIELD_TYPE = "estimated_tax";
